import React from 'react';

export default function Box() {
  return <div className="box"></div>;
}
